var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4311 20.5246C34.5521 12.8397 27.8299 1.35415 18.1248 2.99584C7.9657 -5.43757 -5.52487 7.42844 2.37685 17.9882L1.35214 21.1405V21.1419C1.26397 21.4194 1.33913 21.7244 1.54725 21.9296C1.75683 22.1348 2.06178 22.2056 2.33928 22.1131L5.83837 20.8803V20.8789C7.94707 21.9758 10.3505 22.3733 12.6993 22.012C14.3686 23.4501 16.4311 24.3519 18.6193 24.6034C20.8075 24.8535 23.0204 24.4387 24.9714 23.4154L28.4705 24.6482C28.748 24.7422 29.0544 24.6714 29.2625 24.4661C29.4707 24.2609 29.5458 23.9559 29.4577 23.677L28.4311 20.5246ZM6.2933 19.3683C6.09819 19.2599 5.86695 19.2383 5.65302 19.3062L3.29427 20.1387L3.97211 18.0647L3.97355 18.0661C4.06027 17.8103 4.0039 17.5285 3.82613 17.3261C-3.08103 8.9012 7.10267 -2.4763 16.2285 3.47404C9.26069 5.80967 6.56968 14.8589 11.3334 20.5939H11.3349C9.57305 20.6604 7.82853 20.2355 6.29363 19.3683L6.2933 19.3683Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconWhite);
export default __webpack_public_path__ + "static/media/messageIconWhite.84184e3a49ebd1e6fc7e1285d18f27f5.svg";
export { ForwardRef as ReactComponent };